import { z } from 'zod';
import {
    mockSnapshot,
    Snapshot,
    snapshotSchema,
} from 'app/agriculture/queries/snapshots/types/Snapshot';

export interface ImageSnapshot extends Snapshot {
    imageFilename: string | null;
}

export const imageSnapshotSchema = snapshotSchema.extend({
    imageFilename: z.string().nullable(),
});

export const mockImageSnapshot = ({
    imageFilename = 'path/to/image.png',

    ...snapshot
}: Partial<ImageSnapshot> = {}): ImageSnapshot => ({
    ...mockSnapshot(snapshot),

    imageFilename,
});
